import { setNewRelicAttribute } from './newRelic';

const setNewRelicAttributes = (map) => {
    Object.entries(map).forEach(([key, value]) => {
        if (value) setNewRelicAttribute(key, value);
    });
};
export default setNewRelicAttributes;
